import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';

import { grey } from '@material-ui/core/colors';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';

const styles = {
  root: {
    height: 48,
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
  },
  iconButton: {
    opacity: 0.54,
    transform: 'scale(1, 1)',
    transition: 'transform 200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
  },
  iconButtonHidden: {
    transform: 'scale(0, 0)',
    '& > $icon': {
      opacity: 0,
    },
  },
  iconButtonDisabled: {
    opacity: 0.38,
  },
  searchIconButton: {
    marginRight: -48,
  },
  icon: {
    opacity: 0.54,
    transition: 'opacity 200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
  },
  input: {
    width: '100%',
  },
  searchContainer: {
    margin: 'auto 16px',
    width: 'calc(100% - 48px - 32px)', // 48px button + 32px margin
  },
};

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.initialQuery,
    };
  }

  componentDidMount() {
    if (this.state.value) {
      this.props.onRequestSearch(this.state.value);
    }
  }

  handleFocus = e => {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  };

  handleBlur = e => {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  };

  handleInput = e => {
    const value = e.target.value;
    this.setState({ value });
    // this.handleRequestSearch(value);
  };

  handleCancel = () => {
    this.setState({ value: '' });
    this.handleRequestSearch.cancel();
    if (this.props.onCancelSearch) {
      this.props.onCancelSearch();
    }
  };

  handleKeyUp = e => {
    if (e.charCode === 13 || e.key === 'Enter') {
      this.props.onRequestSearch(this.state.value);
    } else if (
      this.props.cancelOnEscape &&
      (e.charCode === 27 || e.key === 'Escape')
    ) {
      this.handleCancel();
    }
  };

  handleRequestSearch = debounce(
    value => {
      if (this.props.onRequestSearch) {
        this.props.onRequestSearch(value);
      }
    },
    1000,
    { leading: false }
  );

  render() {
    const {
      className,
      classes,
      disabled,
      style,
      loading,
      placeholder,
    } = this.props;
    const { value } = this.state;

    return (
      <Paper
        className={classNames(classes.root, className)}
        style={style}
        elevation={1}
      >
        <div className={classes.searchContainer}>
          <Input
            placeholder={placeholder}
            onBlur={this.handleBlur}
            value={value}
            onChange={this.handleInput}
            onKeyUp={this.handleKeyUp}
            onFocus={this.handleFocus}
            fullWidth
            className={classes.input}
            disableUnderline
            disabled={disabled}
          />
        </div>
        <IconButton
          onClick={() => this.handleRequestSearch.flush()}
          classes={{
            root: classNames(classes.iconButton, classes.searchIconButton, {
              [classes.iconButtonHidden]: value !== '' || loading,
            }),
            disabled: classes.iconButtonDisabled,
          }}
          disabled={disabled}
        >
          <SearchIcon
            style={{ color: grey[500] }}
            classes={{ root: classes.icon }}
          />
        </IconButton>
        <IconButton
          onClick={this.handleCancel}
          classes={{
            root: classNames(classes.iconButton, {
              [classes.iconButtonHidden]: value === '' || loading,
            }),
            disabled: classes.iconButtonDisabled,
          }}
          disabled={disabled}
        >
          <ClearIcon
            style={{ color: grey[500] }}
            classes={{ root: classes.icon }}
          />
        </IconButton>
        {loading ? (
          <CircularProgress
            style={{ position: 'absolute', top: 12, right: 10 }}
            color="primary"
            size={25}
          />
        ) : null}
      </Paper>
    );
  }
}

SearchBar.defaultProps = {
  className: '',
  disabled: false,
  placeholder: 'Suchen',
  style: null,
  value: '',
  initialQuery: '',
};

SearchBar.propTypes = {
  /** Whether to clear search on escape */
  cancelOnEscape: PropTypes.bool,
  /** Override or extend the styles applied to the component. */
  classes: PropTypes.object.isRequired,
  /** Custom top-level class */
  className: PropTypes.string,
  /** Disables text field. */
  disabled: PropTypes.bool,
  /** Fired when the search is cancelled. */
  onCancelSearch: PropTypes.func,
  /** Fired when the text value changes. */
  onRequestSearch: PropTypes.func,
  /** Sets placeholder text for the embedded text field. */
  placeholder: PropTypes.string,
  /** Override the inline-styles of the root element. */
  style: PropTypes.object,
  loading: PropTypes.bool,
  initialQuery: PropTypes.string,
};

export default withStyles(styles)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.jsx